// extracted by mini-css-extract-plugin
export var readonly = "_bs-1";
export var star = "_bs-0";